module.exports = __webpack_public_path__ + "img/logo1.3aa96907.jpg";